module.exports = __webpack_public_path__ + "static/julja_liashchynska-441d7fb312048117b2f08bfd2e06d821.png";